<template>
	<div class="watermark-container" ref="container">
		<!-- <div v-for="(position, index) in watermarkPositions" :key="index" class="watermark" v-show="isShowMark"
			:style="{ top: position.top, left: position.left }">
			<img src="@/assets/watermark.png" />
		</div> -->
		<div class="watermark" v-show="isShowMark">
		</div>
		<slot>
			<!-- 预留出插槽，以便于页面组件的嵌入 -->
		</slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				watermarkText: '中投顾问', // 替换为你需要的水印 ---可根据接口赋值或vuex改变
				watermarkPositions: []
			}
		},
		props: {
			isShowMark: {
				type: Boolean,
				default: false
			},
			refreshNum:{ type: Number,default:1, },//部分筛选项需要带数字排序 刷新数字
		},
		watch:{
			refreshNum:{
				handler(newval,oldval){
					// console.log('刷新',newval)
					this.refreshNum=newval; 
					setTimeout(() => {
						this.addWatermark();
					}, 1000)
				}
			},
		},
		mounted() {
			// console.log('是否显示水印', this.isShowMark)
			setTimeout(() => {
				// this.addWatermarks();
			}, 1000)
			// this.calculateWatermarkPositions(1000,1000);
			// window.addEventListener('resize', this.addWatermark); //监听窗口变化
			  // 监听打印事件
			// window.addEventListener('beforeprint', this.addWatermarks);
			// window.addEventListener('afterprint', this.handleAfterPrint);
		},
		beforeDestroy() {
			// window.removeEventListener('resize', this.addWatermark); //销毁
			 // 移除事件监听器
			// window.removeEventListener('beforeprint', this.addWatermarks);
			// window.removeEventListener('afterprint', this.addWatermark);
		},
		methods: {
			addWatermark() {
				this.watermarkPositions=[]; //要先清空，否则会一直叠加水印
				// 添加水印的逻辑，可以使用 DOM 操作或者 CSS 类添加样式
				// 例如，设置文字颜色、透明度、字体大小、旋转角度等
				const container = this.$refs.container;
				const containerWidth = container.offsetWidth;
				const containerHeight = container.offsetHeight;
				const imgWidth = 1000; // 水印图片的宽度
				const imgHeight = 1000; // 水印图片的高度
				const cols = Math.ceil(containerWidth / imgWidth);
				const rows = Math.ceil(containerHeight / imgHeight);
				// console.log(containerWidth, containerHeight, cols, rows)
				// 创建新的水印图片并设置位置,计算每个水印的位置
				let position = '';
				for (let y = 0; y < rows; y++) {
					for (let x = 0; x < cols; x++) {
						position = {
							top: `${(y * imgWidth) }px`,
							left: `${(x * imgHeight)}px` //设置水平间距多加160，可以根据需要调整
						};
						this.watermarkPositions.push(position);
					}
				}
				// console.log(this.watermarkPositions)
			},
			addWatermarks() {
				console.log('3e213ljdsajf,监听打印前时间');
			     const container = this.$refs.container;
			     const containerWidth = container.offsetWidth;
			     const containerHeight = container.offsetHeight;
			      var watermarkWidth = 1000;
			      var watermarkHeight = 1000; /* 将水印高度调整为与宽度相同，以填充整个页面 */
			      var rows = Math.ceil(containerHeight / watermarkHeight);
			      var cols = Math.ceil(containerWidth / watermarkWidth);
			  
			      // container.className = 'watermark-container';
			      // document.body.appendChild(container);
				  let position='';
			      for (var i = 0; i < rows; i++) {
			        for (var j = 0; j < cols; j++) {
					  position = {
						  top: `${(i * watermarkHeight) -1000}px`,
						  left: `${(j * watermarkWidth)}px` //设置水平间距多加160，可以根据需要调整
					  };
					  this.watermarkPositions.push(position);
			        }
					
			      }
			    }
		}
	}
</script>

<style>
	.watermark-container {
		position: relative;
		width: 100%;
		min-height: 750px;
		/* overflow: hidden; */
	}
	@media print {
	  .watermark{
		  /* 打印强制显示背景 */
	    -webkit-print-color-adjust: exact; 
	  }
	}
	.watermark {
		position: absolute;
		/* top: 50%;
		left: 50%; */
		/* transform: rotate(-25deg); */
		/* color: rgba(0, 0, 0, 0.3); */
		/* font-size: 20px; */
		/* 禁止换行 */
		white-space: nowrap;
		/* 禁止鼠标事件 */
		pointer-events: none;
		/* 确保水印在最顶层 */
		z-index: 999;
		/* 设置水印透明度 */
		/* opacity: 0.7; */
		/* 指定水印图片路径 */
		background-image: url('../../assets/chanyeyanjiuWater.png');
		/* 设置水印平铺方式 */
		background-repeat: repeat;
		width: 100%;
		height: 100%;
	}
</style>